import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { refresh } from "./store/slices/auth/asyncThunks.js";

import GlobalStyles from "./styles/globalStyles";
import "./styles/index.css";

import SplashScreen from "./components/SplashScreen/SplashScreen";
import DeliveryPage from "./screens/DeliveryPage.js";
import ProductPage from "./screens/ProductPage.js";
import CartPage from "./screens/CartPage.js";
import AboutPage from "./screens/AboutPage.js";
import ShopPage from "./screens/ShopPage.js";
import AdminPage from "./screens/AdminPage.js";
import LoginPage from "./screens/LoginPage.js";
import SuccessPage from "./screens/SuccessPage.js";
import HomePage from "./screens/HomePage.js";
import ProtectedRoute from "./components/ProtectedRoute.js";
import { getCategories } from "./store/slices/products/asyncThunks.js";
import { selectLoggedIn, setLoggedIn } from "./store/slices/auth/slice.js";

import { lineSpinner } from "ldrs";
import EditPage from "./screens/EditPage.js";
import CategoryPage from "./screens/CategoryPage.js";
import { getAdminUserInfo } from "./store/slices/user/asyncThunks.js";
import OrdersPage from "./screens/OrdersPage.js";
import CouponPage from "./screens/CouponPage.js";
import BundlePage from "./screens/BundlePage.js";
import MessagesPage from "./screens/MessagesPage.js";
import DashboardPage from "./screens/DashboardPage.js";
import CheckoutPage from "./screens/CheckoutPage.js";
import NotFoundPage from "./screens/NotFoundPage.js";
import PageTitle from "./components/utils/PageTitle";

lineSpinner.register();

function App() {
  const loggedIn = useSelector(selectLoggedIn);
  const dispatch = useDispatch();
  const [minimumDurationPassed, setMinimumDurationPassed] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setMinimumDurationPassed(true), 1550);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    dispatch(getCategories());
  }, []);

  useEffect(() => {
    dispatch(refresh())
      .unwrap()
      .then(() => {
        dispatch(getAdminUserInfo())
          .unwrap()
          .then(() => {})
          .catch((err) => console.log(err.message));
      })
      .catch(() => {
        dispatch(setLoggedIn({ loggedIn: false }));
      });
  }, []);

  return (
    <Fragment>
      <GlobalStyles />

      <PageTitle />

      {minimumDurationPassed ? (
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/prodavnica" element={<ShopPage />} />
          <Route path="/korpa" element={<CartPage />} />
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route path="/dostava" element={<DeliveryPage />} />
          <Route path="/proizvod/:id" element={<ProductPage />} />
          <Route path="/o-nama" element={<AboutPage />} />
          <Route path="/administracija" element={<LoginPage />} />
          <Route path="/uspesna-porudzbina" element={<SuccessPage />} />

          {minimumDurationPassed && loggedIn !== null && (
            <Route element={<ProtectedRoute />}>
              <Route path="/kontrolna-tabla" element={<AdminPage />} />
              <Route
                path="/kontrolna-tabla/dashboard"
                element={<DashboardPage />}
              />
              <Route path="/kontrolna-tabla/edit/:id" element={<EditPage />} />
              <Route
                path="/kontrolna-tabla/porudzbine"
                element={<OrdersPage />}
              />
              <Route
                path="/kontrolna-tabla/kategorije"
                element={<CategoryPage />}
              />
              <Route path="/kontrolna-tabla/kuponi" element={<CouponPage />} />
              <Route
                path="/kontrolna-tabla/bundlovi"
                element={<BundlePage />}
              />
              <Route
                path="/kontrolna-tabla/poruke"
                element={<MessagesPage />}
              />
            </Route>
          )}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      ) : (
        <SplashScreen />
      )}
    </Fragment>
  );
}

export default App;
